import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Sales.css';

const SellerSalesType = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSaleTypeSelection = (type) => {
    if (type === 'quick') {
      // Navegar a la página de venta rápida para vendedor
      navigate('/seller-sales', { state: { saleType: 'quick' } });
    } else if (type === 'detailed') {
      // Navegar a la página de venta detallada para vendedor
      navigate('/seller-sales', { state: { saleType: 'detailed' } });
    }
  };

  const handleBackToDashboard = () => {
    navigate('/seller-dashboard');
  };

  return (
    <div className="sales-container">
      <header className="sales-header">
        <h1>Registro de Ventas</h1>
        <button onClick={handleBackToDashboard} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      <div className="sale-type-selection">
        <h2>Seleccione el tipo de venta</h2>
        <div className="sale-type-buttons">
          <button 
            className="sale-type-btn quick-sale-btn"
            onClick={() => handleSaleTypeSelection('quick')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            <span>Venta Rápida</span>
            <p>Registre una venta con información mínima</p>
          </button>
          <button 
            className="sale-type-btn detailed-sale-btn"
            onClick={() => handleSaleTypeSelection('detailed')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
            <span>Venta Detallada</span>
            <p>Registre una venta con todos los detalles</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SellerSalesType;
